/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createDocumentListResponseFromDiscriminatorValue, createErrorResponseFromDiscriminatorValue, createInternalErrorResponseFromDiscriminatorValue, type DocumentListResponse, type ErrorResponse, type InternalErrorResponse } from '../../../models/index.js';
// @ts-ignore
import { BulkDeleteRequestBuilderRequestsMetadata, type BulkDeleteRequestBuilder } from './bulkDelete/index.js';
// @ts-ignore
import { BulkMoveRequestBuilderRequestsMetadata, type BulkMoveRequestBuilder } from './bulkMove/index.js';
// @ts-ignore
import { type WithDocumentItemRequestBuilder, WithDocumentItemRequestBuilderNavigationMetadata, WithDocumentItemRequestBuilderRequestsMetadata } from './item/index.js';
// @ts-ignore
import { type UploadRequestBuilder, UploadRequestBuilderRequestsMetadata } from './upload/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type KeysToExcludeForNavigationMetadata, type NavigationMetadata, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /api/companydocs/documents
 */
export interface DocumentsRequestBuilder extends BaseRequestBuilder<DocumentsRequestBuilder> {
    /**
     * The bulkDelete property
     */
    get bulkDelete(): BulkDeleteRequestBuilder;
    /**
     * The bulkMove property
     */
    get bulkMove(): BulkMoveRequestBuilder;
    /**
     * The upload property
     */
    get upload(): UploadRequestBuilder;
    /**
     * Gets an item from the MomentumAPI.api.companydocs.documents.item collection
     * @param documentId Unique identifier of the item
     * @returns {WithDocumentItemRequestBuilder}
     */
     byDocumentId(documentId: string) : WithDocumentItemRequestBuilder;
    /**
     * Returns the documents in one folder of the organization's library. Pass folderId to list that folder's contents; leave it out and you get only the documents that sit outside every folder, not the whole library. There is no single call that returns everything — read the folders endpoint and call this once per folder to walk the tree. Listing is not recursive: a folder's subfolders' documents are not included. Each entry carries a time-limited cdnUrl that may already have expired; refresh a link individually when you need it, or stream the file through the download endpoint instead.
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<DocumentListResponse>}
     * @throws {ErrorResponse} error when the service returns a 400 status code
     * @throws {ErrorResponse} error when the service returns a 403 status code
     * @throws {InternalErrorResponse} error when the service returns a 500 status code
     */
     get(requestConfiguration?: RequestConfiguration<DocumentsRequestBuilderGetQueryParameters> | undefined) : Promise<DocumentListResponse | undefined>;
    /**
     * Returns the documents in one folder of the organization's library. Pass folderId to list that folder's contents; leave it out and you get only the documents that sit outside every folder, not the whole library. There is no single call that returns everything — read the folders endpoint and call this once per folder to walk the tree. Listing is not recursive: a folder's subfolders' documents are not included. Each entry carries a time-limited cdnUrl that may already have expired; refresh a link individually when you need it, or stream the file through the download endpoint instead.
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toGetRequestInformation(requestConfiguration?: RequestConfiguration<DocumentsRequestBuilderGetQueryParameters> | undefined) : RequestInformation;
}
/**
 * Returns the documents in one folder of the organization's library. Pass folderId to list that folder's contents; leave it out and you get only the documents that sit outside every folder, not the whole library. There is no single call that returns everything — read the folders endpoint and call this once per folder to walk the tree. Listing is not recursive: a folder's subfolders' documents are not included. Each entry carries a time-limited cdnUrl that may already have expired; refresh a link individually when you need it, or stream the file through the download endpoint instead.
 */
export interface DocumentsRequestBuilderGetQueryParameters {
    /**
     * The folder to list. Leave it out to get only the documents that sit outside every folder —there is no value that returns the whole library in one call.
     */
    folderId?: string;
}
/**
 * Uri template for the request builder.
 */
export const DocumentsRequestBuilderUriTemplate = "{+baseurl}/api/companydocs/documents{?folderId*}";
/**
 * Metadata for all the navigation properties in the request builder.
 */
export const DocumentsRequestBuilderNavigationMetadata: Record<Exclude<keyof DocumentsRequestBuilder, KeysToExcludeForNavigationMetadata>, NavigationMetadata> = {
    byDocumentId: {
        requestsMetadata: WithDocumentItemRequestBuilderRequestsMetadata,
        navigationMetadata: WithDocumentItemRequestBuilderNavigationMetadata,
        pathParametersMappings: ["documentId"],
    },
    bulkDelete: {
        requestsMetadata: BulkDeleteRequestBuilderRequestsMetadata,
    },
    bulkMove: {
        requestsMetadata: BulkMoveRequestBuilderRequestsMetadata,
    },
    upload: {
        requestsMetadata: UploadRequestBuilderRequestsMetadata,
    },
};
/**
 * Metadata for all the requests in the request builder.
 */
export const DocumentsRequestBuilderRequestsMetadata: RequestsMetadata = {
    get: {
        uriTemplate: DocumentsRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            403: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            500: createInternalErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createDocumentListResponseFromDiscriminatorValue,
    },
};
/* tslint:enable */
/* eslint-enable */
